addEventListener('turbo:before-cache', () => {
	const turboModal = document.querySelector('#turbo-modal')
	if (turboModal) {
		for (const modalElement of turboModal.querySelectorAll('.modal')) {
			turboModal.removeChild(modalElement)
		}

		// When leaving a page with a modal open, the cached body's style gets stuck in Bootstrap's modal behavior. This seems to be a suitable fix.
		document.body.classList.remove('modal-open')
		document.body.style.overflow = null
		document.body.style.paddingRight = null
	}
})
